import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createTextVNode as _createTextVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, createVNode as _createVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-20dc48c0"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "container" };
const _hoisted_2 = { class: "row" };
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "col-4" }, "Enabled", -1));
const _hoisted_4 = { class: "col-4" };
const _hoisted_5 = { class: "col-4" };
const _hoisted_6 = /*#__PURE__*/ _createTextVNode("Disable");
const _hoisted_7 = /*#__PURE__*/ _createTextVNode("Enable");
const _hoisted_8 = { class: "row" };
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "col-4" }, "Status", -1));
const _hoisted_10 = { class: "col-4" };
import { Icon, Button } from '@/components/UI';
import useStreamdeck from '@/compositions/useStreamdeck';
import { computed } from 'vue';
// @ts-ignore
import Popper from 'vue3-popper';
export default /*#__PURE__*/ _defineComponent({
    setup(__props) {
        const { enabled, enable, disable, connected } = useStreamdeck();
        const classes = computed(() => {
            return {
                "streamdeck-icon": true,
                "disabled": !enabled.value,
                "connecting": enabled.value && !connected.value,
                "connected": enabled.value && connected.value
            };
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", null, [
                _createVNode(_unref(Popper), { hover: true }, {
                    content: _withCtx(() => [
                        _createElementVNode("div", _hoisted_1, [
                            _createElementVNode("div", _hoisted_2, [
                                _hoisted_3,
                                _createElementVNode("div", _hoisted_4, [
                                    (_unref(enabled))
                                        ? (_openBlock(), _createBlock(_unref(Icon), {
                                            key: 0,
                                            name: "circle-check green"
                                        }))
                                        : (_openBlock(), _createBlock(_unref(Icon), {
                                            key: 1,
                                            name: "circle-xmark red"
                                        }))
                                ]),
                                _createElementVNode("div", _hoisted_5, [
                                    (_unref(enabled))
                                        ? (_openBlock(), _createBlock(_unref(Button), {
                                            key: 0,
                                            onClick: _unref(disable),
                                            size: "sm"
                                        }, {
                                            default: _withCtx(() => [
                                                _hoisted_6
                                            ]),
                                            _: 1
                                        }, 8, ["onClick"]))
                                        : (_openBlock(), _createBlock(_unref(Button), {
                                            key: 1,
                                            onClick: _unref(enable),
                                            size: "sm"
                                        }, {
                                            default: _withCtx(() => [
                                                _hoisted_7
                                            ]),
                                            _: 1
                                        }, 8, ["onClick"]))
                                ])
                            ]),
                            _createElementVNode("div", _hoisted_8, [
                                _hoisted_9,
                                _createElementVNode("div", _hoisted_10, [
                                    (_unref(connected))
                                        ? (_openBlock(), _createBlock(_unref(Icon), {
                                            key: 0,
                                            name: "circle-check green"
                                        }))
                                        : (_openBlock(), _createBlock(_unref(Icon), {
                                            key: 1,
                                            name: "circle-xmark red"
                                        }))
                                ])
                            ])
                        ])
                    ]),
                    default: _withCtx(() => [
                        _createElementVNode("div", {
                            class: _normalizeClass(_unref(classes))
                        }, null, 2)
                    ]),
                    _: 1
                })
            ]));
        };
    }
});
